import dynamic from "next/dynamic";
import { getProductsByCategory } from "@/services/category";

import { handShake } from "@/services/handshake";
import WhiteSpace from "@/components/home/WhiteSpace";

import LazyLoading from "@/components/LazyLoading";

import FeaturedCategories from "@/components/home/FeaturedCategories"; // eager
import MainBanners from "@/components/global/swiper/MainBanners"; // eager
import Categories from "@/components/global/swiper/Categories"; // eager
import StaticBanners from "@/components/home/StaticBanners"; // eager

// const StaticBanners = dynamic(() => import("@/components/home/StaticBanners"), {
//   loading: () => (
//     <LazyLoading parentClassName={"min-h-[250px] sm:min-h-[500px]"} />
//   ),
// });

const ProductsTabs = dynamic(() => import("@/components/home/ProductsTabs"), {
  loading: () => (
    <LazyLoading parentClassName={"min-h-[350px] sm:min-h-[450px]"} />
  ),
});
const VideoSection = dynamic(() => import("@/components/home/VideoSection"), {
  loading: () => (
    <LazyLoading parentClassName={"min-h-[260px] sm:min-h-[400px]"} />
  ),
});
const Brands = dynamic(() => import("@/components/home/Brands"), {
  loading: () => <LazyLoading parentClassName={"min-h-[200px]"} />,
});
const EffectCardSwiper = dynamic(
  () => import("@/components/global/swiper/EffectCardSwiper"),
  {
    loading: () => (
      <LazyLoading parentClassName={"min-h-[300px] sm:min-h-[550px]"} />
    ),
  }
);
const SingleBanner = dynamic(() => import("@/components/home/SingleBanner"), {
  loading: () => <LazyLoading parentClassName={"min-h-[200px]"} />,
});

export const getTabsData = async (handshake, tabs) => {
  if ("tabs" in tabs) {
    const tabsOneApis = tabs?.tabs?.map(({ id }) =>
      getProductsByCategory(handshake, id, 10, 0, "")
    );
    const tabsData = await Promise.allSettled(tabsOneApis);
    const tabsProducts = tabs.tabs.map((tab, idx) => ({
      ...tab,
      products: tabsData[idx]?.value?.data?.data?.products || [],
    }));
    return { ...tabs, tabs: tabsProducts, tabsData };
  }
  return tabs;
};
export const getTabsDataV2 = async (handshake, locale, tabs) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const res = await handShake(locale);
  const token = res?.data?.token;
  if ("value" in tabs) {
    const tabsOneApis = tabs?.value?.map(({ id }) =>
      getProductsByCategory(token, id, 15, 0, false)
    );
    const tabsData = await Promise.all(tabsOneApis);
    console.log("tabsData =======================>", token);
    const tabsProducts = tabs.value
      .map((tab, idx) => ({
        ...tab,
        products: (tabsData[idx]?.data?.data?.products || [])?.filter(
          (item) => item?.stock?.is_in_stock
        ),
      }))
      .filter((tab) => tab.products?.length);
    return { ...tabs, value: tabsProducts };
  }
  return tabs;
};

// eslint-disable-next-line no-unused-vars
export const renderHomeSection = (sectionType, data, t, isMobile) => {
  switch (sectionType) {
    case "highlighted-categories":
      return <FeaturedCategories data={data} />; // eager
    case "main-banners":
      return <MainBanners data={data} isMobile={isMobile} />; // eager
    case "categories":
      return <Categories homeData={data} isNew />; // eager
    case "two-main-banners":
      return <StaticBanners data={data} isNew />; // eager
    case "tabs":
      return <ProductsTabs data={data} isNew t={t} />;
    case "swapper-banners":
      return <VideoSection data={data} />;
    case "brands":
      return <Brands data={data} t={t} isNew />;
    case "effective-slider":
      return <EffectCardSwiper data={data} />;
    case "one-second-banners":
      return <SingleBanner data={data} />;
    case "white-spacing":
      return <WhiteSpace data={data} />;
    default:
      return null;
  }
};
